var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmericaFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2_5736)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_5736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_5736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 25,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2,
    width: 24,
    height: 16,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_5736)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 2H27.5V18H3.5V2Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16.6663V18.0003H3.5V16.6663H27.5ZM27.5 15.3333H3.5V14.0003H27.5V15.3333ZM27.5 12.6663H3.5V11.3333H27.5V12.6663ZM27.5 10.0003H3.5V8.66634H27.5V10.0003ZM27.5 7.33333H3.5V6.00032H27.5V7.33333ZM27.5 4.66634H3.5V3.33333H27.5V4.66634Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2,
    width: 13.5,
    height: 9.33333,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2161 3.46751H16.0022L15.385 4.0222L15.6243 4.89818L14.8547 4.40599L14.218 4.80052H14.5022L13.885 5.35619L14.0979 6.13451H14.5442L14.8538 5.41966L15.2161 6.13451H16.0022L15.385 6.68919L15.6243 7.56517L14.8547 7.07298L14.218 7.46751H14.5022L13.885 8.0222L14.0979 8.80052H14.5442L14.8538 8.08568L15.2161 8.80052H16.0022L15.385 9.35619L15.6243 10.2322L14.8547 9.73997L14.0598 10.2322L14.3284 9.35619L13.6223 8.80052H13.9719L13.3547 8.40599L12.718 8.80052H13.0022L12.385 9.35619L12.6243 10.2322L11.8547 9.73997L11.0598 10.2322L11.3284 9.35619L10.6223 8.80052H10.9719L10.3547 8.40599L9.71802 8.80052H10.0022L9.38501 9.35619L9.62427 10.2322L8.85474 9.73997L8.05981 10.2322L8.32837 9.35619L7.62231 8.80052H7.97192L7.35474 8.40599L6.71802 8.80052H7.0022L6.38501 9.35619L6.62427 10.2322L5.85474 9.73997L5.05981 10.2322L5.32837 9.35619L4.62231 8.80052H5.54419L5.85376 8.08568L6.21606 8.80052H6.59009L6.82837 8.0222L6.12231 7.46751H6.47192L5.85474 7.07298L5.05981 7.56517L5.32837 6.68919L4.62231 6.13451H5.54419L5.85376 5.41966L6.21606 6.13451H6.59009L6.82837 5.35619L6.12231 4.80052H6.47192L5.85474 4.40599L5.05981 4.89818L5.32837 4.0222L4.62231 3.46751H5.54419L5.85376 2.75267L6.21606 3.46751H7.0022L6.38501 4.0222L6.5979 4.80052H7.04419L7.35376 4.08568L7.71606 4.80052H8.09009L8.32837 4.0222L7.62231 3.46751H8.54419L8.85376 2.75267L9.21606 3.46751H10.0022L9.38501 4.0222L9.5979 4.80052H10.0442L10.3538 4.08568L10.7161 4.80052H11.0901L11.3284 4.0222L10.6223 3.46751H11.5442L11.8538 2.75267L12.2161 3.46751H13.0022L12.385 4.0222L12.5979 4.80052H13.0442L13.3538 4.08568L13.7161 4.80052H14.0901L14.3284 4.0222L13.6223 3.46751H14.5442L14.8538 2.75267L15.2161 3.46751ZM11.218 7.46751H11.5022L10.885 8.0222L11.0979 8.80052H11.5442L11.8538 8.08568L12.2161 8.80052H12.5901L12.8284 8.0222L12.1223 7.46751H12.4719L11.8547 7.07298L11.218 7.46751ZM8.21802 7.46751H8.5022L7.88501 8.0222L8.0979 8.80052H8.54419L8.85376 8.08568L9.21606 8.80052H9.59009L9.82837 8.0222L9.12231 7.46751H9.47192L8.85474 7.07298L8.21802 7.46751ZM12.718 6.13451H13.0022L12.385 6.68919L12.5979 7.46751H13.0442L13.3538 6.75267L13.7161 7.46751H14.0901L14.3284 6.68919L13.6223 6.13451H13.9719L13.3547 5.73997L12.718 6.13451ZM6.71802 6.13451H7.0022L6.38501 6.68919L6.5979 7.46751H7.04419L7.35376 6.75267L7.71606 7.46751H8.09009L8.32837 6.68919L7.62231 6.13451H7.97192L7.35474 5.73997L6.71802 6.13451ZM9.71802 6.13451H10.0022L9.38501 6.68919L9.5979 7.46751H10.0442L10.3538 6.75267L10.7161 7.46751H11.0901L11.3284 6.68919L10.6223 6.13451H10.9719L10.3547 5.73997L9.71802 6.13451ZM8.21802 4.80052H8.5022L7.88501 5.35619L8.0979 6.13451H8.54419L8.85376 5.41966L9.21606 6.13451H9.59009L9.82837 5.35619L9.12231 4.80052H9.47192L8.85474 4.40599L8.21802 4.80052ZM11.218 4.80052H11.5022L10.885 5.35619L11.0979 6.13451H11.5442L11.8538 5.41966L12.2161 6.13451H12.5901L12.8284 5.35619L12.1223 4.80052H12.4719L11.8547 4.40599L11.218 4.80052Z",
    fill: "#F7FCFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2_5736",
    x: 0.5,
    y: 0,
    width: 30,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_5736"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2_5736",
    result: "effect2_dropShadow_2_5736"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_5736",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_5736"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2,
    width: 24,
    height: 16,
    rx: 1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericaFlag);
export default __webpack_public_path__ + "static/media/america-flag.755368e773ac82058978f44755753bf2.svg";
export { ForwardRef as ReactComponent };